import React, { Component } from 'react';
import { Row } from 'react-bootstrap';

export default class PrivacyPolicy extends Component {
  /*
    This component will show if the user enters a path that does not match any of the routes.
  */

  render() {
    return (
      <Row>
        <div className="box">
          <div className="header">
            <h2>Personvernerklæring</h2>
          </div>
          <p style={{ margin: '20px 35px' }}>
            På denne siden kan du lese mer om hvordan vi håndterer ditt
            personvern, og hvilken data vi lagrer. Du kan også be oss om å
            slette all data vi har lagret om deg.
          </p>
          <h4 style={{ margin: '35px 35px 20px' }}>
            Hvilken data lagrer vi om deg, og hvorfor?
          </h4>

          <p style={{ margin: '20px 35px' }}>
            Personopplysninger er data og vurderinger som kan knyttes til en
            enkeltperson. Dette kan for eksempel være navn, bosted,
            telefonnummer, e-postadresse og ip-adresse, eller en kombinasjon av
            disse som gjør det mulig å anslå hvilken person som befinner seg bak
            dataene.
          </p>
          <p style={{ margin: '20px 35px' }}>
            Når du registrerer deg benytter vi Facebook-innlogging for å hente
            litt informasjon om deg. Vi lagrer ditt navn og e-postadresse. Dette
            er det minste av informasjonen vi trenger om deg for at nettsiden
            skal kunne knytte dine investeringer til deg, og
            behandlingsgrunnlaget for dataen er derfor «nødvendig for avtale».
            E-post blir benyttet for å kommunisere informasjon om porteføljen
            din til deg.
          </p>
          <p style={{ margin: '20px 35px' }}>
            Vi bruker ingen form for informasjonskapsler for å spore deg, annet
            enn en informasjonskapsel for at du skal kunne logge deg inn.
          </p>
          <p style={{ margin: '20px 35px' }}>
            Vi gir aldri dataen din videre til en tredjepart.
          </p>

          <h4 style={{ margin: '35px 35px 20px' }}>Slett data</h4>
          <p style={{ margin: '20px 35px' }}>
            Når du legger inn dine investeringer hos oss, lagrer vi informasjon
            om investeringene dine i våre systemer. Du kan når som helst be oss
            om å slette all data vi har lagret om deg ved å sende en e-post til
            eirik@bustbyte.no.
          </p>
          <p style={{ margin: '20px 35px' }}>
            I henhold til GDPR har du en rett til å bli glemt, det vil si at du
            kan kreve sletting av egne personopplysninger. Du kan ikke kreve at
            opplysninger slettes dersom det fortsatt er nødvendig å ta vare på
            opplysningene for å oppnå formålet med behandlingen. Send inn en
            henvendelse på e-post dersom du ønsker at all data om deg skal
            slettes.
          </p>
          <p style={{ margin: '20px 35px 35px' }}>
            Forespørselen om å bli slettet vil også bli slettet i løpet av 3
            måneder.
          </p>
        </div>
      </Row>
    );
  }
}
